import { SuccessMessage } from 'components/calls/atoms/Toast';
import copy from 'copy-to-clipboard';
import { toast } from 'react-toastify';
import { ROOM_ID_KEY } from 'components/calls/organisms/group-call';
import { PSA_ID_KEY } from 'components/class/psa/psa-row/psa-actions';
import { VideoAssignmentSubmission } from 'types/VideoAssignmentSubmission';

interface GenerateWatchLinkProps {
  videoId: string;
  userId: number;
  videoPath: string;
  assignmentId: string;
}

// Term IDs >= 35 use PSD/PSA naming.
export const PSD_MIN_TERM_ID = 35;
export const isPsdTerm = (termId?: number | null): boolean => (termId ?? 0) >= PSD_MIN_TERM_ID;

export const CURRENT_VIDEOS_KEY = 'currentSubmissionVideosLength';
export const VIDEO_PROCESSING_KEY = 'video_processing';
export const VIDEO_CREATED_DATE = 'video_create_date';
export const SENDBIRD_POLLING_START_KEY = 'sendbirdPollingStart';

export const generateWatchLink = ({
  videoId,
  userId,
  videoPath,
  assignmentId,
}: GenerateWatchLinkProps) => {
  const checkIfVideoPathHasCoachingInItRegex = /coaching-videos/;
  const watchLink = checkIfVideoPathHasCoachingInItRegex.test(videoPath || '')
    ? `/user/classes/calls/watch/${assignmentId}/${videoId}?userId=${userId}`
    : `/user/classes/calls/watch/${assignmentId}/${videoId}?userId=${userId}&coaching=false`;

  return watchLink;
};

export const generateJoinLink = (userId: number, assignmentId: string): string => {
  const baseUrl =
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:3000'
      : `https://${window.location.hostname}`;

  return `${baseUrl}/user/classes/calls/join/${String(userId)}/${assignmentId}`;
};

export const copyToClipboardAndNotify = (text: string) => {
  copy(text);
  toast(<SuccessMessage message={'Link copied.'} />, { autoClose: 2000 });
};

export const getSubmissionVideoLength = (submission: VideoAssignmentSubmission[]) => {
  const currentPsa = localStorage.getItem(PSA_ID_KEY) ? localStorage.getItem(PSA_ID_KEY) : '';
  return submission
    ? submission.find(
        (submission: VideoAssignmentSubmission) => submission.assignmentId === currentPsa
      )?.videos?.length || 0
    : 0;
};

export const cleanup = (interval: NodeJS.Timeout) => {
  clearInterval(interval);
  localStorage.removeItem(ROOM_ID_KEY);
  localStorage.removeItem(CURRENT_VIDEOS_KEY);
  localStorage.removeItem(SENDBIRD_POLLING_START_KEY);
  
};

export const getVideoProcessingFromLocalStorage = () => {
  const videoProcessing = JSON.parse(localStorage.getItem(VIDEO_PROCESSING_KEY));
  if (videoProcessing) {
    return videoProcessing;
  }
  return false;
};

export const getCurrentVideoCreateDate = (date: string | number): number => {
  let currentDate: number;

  if (localStorage.getItem(VIDEO_CREATED_DATE)) {
    currentDate = new Date(Number(localStorage.getItem(VIDEO_CREATED_DATE))).getTime();
  } else {
    currentDate = new Date(date).getTime();
    localStorage.setItem(VIDEO_CREATED_DATE, currentDate.toString());
  }
  return currentDate;
};
